<template>
    <div :id="component_data.id" class="font-responsive xtype_subsection_header">
        <h2 class="" v-html="component_data.title"></h2>
    </div>
</template>

<script>
export default {
    props: ['component_data']
}
</script>

<style scoped>
    .xtype_subsection_header {
        background-color: #FAF9F7;
        width: 100%;
        margin: -2.4em auto -7.2em;
    }
    .xtype_subsection_header h2 {
        width: 66.666%;
        padding: 1.5em 0 2.5em;
        margin: 0 auto;
        color: #E41429;
        font-size: 4.8em;
        font-family: 'Uni Neue';
        font-weight: 700;
        position: relative;
    }
    @media(max-width: 748px){
        .xtype_subsection_header h2 {
            /* text-align: center; */
            padding: 1em 4.16%;
            width: 100%;
        }
    }
</style>
<style>
    .xtype_subsection_header h2 a {
        background: linear-gradient(to left, #AE0B11, #E41429);
        color:white;
        text-transform: uppercase;
        font-weight: 600;
        font-size: .33em;
        padding: 1em 1.5em;
        display: block;
        position: absolute;
        right: 0;
        top: 4.7em;
        border-radius:100px;
        font-family: 'Lato', sans-serif;
        transition-duration: .3s;
    }
    @media(max-width: 748px){
        .xtype_subsection_header h2 a {
            display: inline-block;
            position: relative;
            top: 0;

        }
    }

    .xtype_subsection_header h2 a:hover {
        text-decoration: none;
        box-shadow: 0 10px 18px -10px rgba(0,0,0,.5) 
    }
</style>

